import { dispatch } from '../internal';
import * as actionTypes from './actionTypes';
export const redirect = (path, options = {}) => {
    var _a;
    if (options.preserveQuery) {
        path = path + window.location.search;
    }
    return dispatch({
        type: actionTypes.REDIRECT,
        payload: { path, replace: (_a = options.replace) !== null && _a !== void 0 ? _a : false },
    });
};
//# sourceMappingURL=actions.js.map